(function () {
  document.querySelectorAll('[data-lifestyle-marquee]').forEach(function (rail) {
    var track = rail.querySelector('[data-lifestyle-track]');
    var original = rail.querySelector('[data-lifestyle-group="original"]');
    if (!track || !original) return;
    var previousDistance = 0;
    function arrange() {
      var distance = original.getBoundingClientRect().width;
      if (!distance) return;
      var total = Math.max(2, Math.ceil(rail.clientWidth / distance) + 1);
      while (track.children.length > total) track.lastElementChild.remove();
      while (track.children.length < total) {
        var clone = original.cloneNode(true);
        clone.setAttribute('data-lifestyle-group', 'clone');
        clone.setAttribute('aria-hidden', 'true');
        // Repeated pictures select their same CMS source field when clicked.
        clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
        track.appendChild(clone);
      }
      if (Math.abs(distance - previousDistance) > 0.1) {
        rail.style.setProperty('--lifestyle-distance', distance + 'px');
        rail.style.setProperty('--lifestyle-duration', distance / (Number(rail.dataset.marqueeSpeed) || 32) + 's');
        previousDistance = distance;
      }
      rail.setAttribute('data-marquee-ready', '');
    }
    arrange();
    new ResizeObserver(arrange).observe(rail);
    new ResizeObserver(arrange).observe(original);
    original.querySelectorAll('img').forEach(function (image) {
      image.addEventListener('load', arrange, { once: true });
    });
  });
})();
